import React, { useMemo, useEffect, useState } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createEmotionCache from "./createEmotionCache";
import getTheme from "./theme";
import { useTranslation } from "react-i18next";
import ThemeContext from "./ThemeContext";

const ThemeWrapper = ({ children }) => {
  const { i18n } = useTranslation();

  // light And Dark mode
  const [mode, setMode] = useState(() => {
    return localStorage.getItem("themeMode") || "light";
  });

  // Direction (RTL or LTR)
  const direction = i18n.language === "ar" ? "rtl" : "ltr";

  // Emotion Cache depending on direction
  const cache = useMemo(() => createEmotionCache(direction), [direction]);

  // Theme depending on mode and direction
  const theme = useMemo(() => getTheme(mode, direction), [mode, direction]);

  // Change the direction of the page (HTML dir)
  useEffect(() => {
    document.documentElement.setAttribute("dir", direction);
    document.body.setAttribute("dir", direction);
  }, [direction]);

  return (
    <CacheProvider value={cache}>
      <ThemeContext.Provider value={{ mode, setMode }}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {children}
        </ThemeProvider>
      </ThemeContext.Provider>
    </CacheProvider>
  );
};

export default ThemeWrapper;
